import PageActionCreators from 'actions/framework/PageActionCreators';
import { SET_MY_LISTS } from 'constants/actionTypes/myLists';
import shoppingListApi from 'services/api/profile/shoppingList';
import LOCAL_STORAGE from 'utils/localStorage/Constants';
import LoveActions from 'actions/LoveActions';
import PageTemplateType from 'constants/PageTemplateType';
import { MIN_ITEMS_PER_PAGE } from 'constants/sharableList';
const { CACHE_ALL_LIST, CACHE_FULL } = LOCAL_STORAGE;
import Storage from 'utils/localStorage/Storage';
class MyListsActionCreators extends PageActionCreators {
    isNewPage = () => true;

    updatePage = () => ({});

    openPage = ({ events: { onPageUpdated, onDataLoaded, onError } }) => {
        return async (dispatch, getState) => {
            try {
                const { user, loves, page } = getState();

                let data = {};
                let allLovedItems = {};

                if (user?.beautyInsiderAccount?.biAccountId) {
                    const options = { itemsPerPage: MIN_ITEMS_PER_PAGE };
                    data = await shoppingListApi.getAllLists(
                        user.beautyInsiderAccount.biAccountId,
                        {
                            key: CACHE_ALL_LIST,
                            invalidate: loves.isLoveListUpdated
                        },
                        options
                    );

                    // the user comes from ProductPage
                    if (
                        page.templateInformation?.template === PageTemplateType.ProductPage &&
                        loves.totalLovesListItemsCount >= 60 &&
                        loves.currentLovesSkuDetails.length >= 60
                    ) {
                        allLovedItems = { skus: loves.currentLovesSkuDetails };
                    } else {
                        // if user is not coming from productPage we remove the scroll position
                        // and fetch all loved items from API
                        Storage.local.removeItem(LOCAL_STORAGE.MY_LISTS_SCROLL_POSITION);
                        allLovedItems = await shoppingListApi.getSkusFromAllLists(
                            user.beautyInsiderAccount.biAccountId,
                            { key: CACHE_FULL, invalidate: true },
                            { itemsPerPage: 60, currentPage: 1, includeCategories: true }
                        );
                    }
                }

                dispatch({
                    type: SET_MY_LISTS,
                    payload: data
                });

                if (allLovedItems?.categories) {
                    dispatch(
                        LoveActions.updateListCategories({
                            categories: allLovedItems.categories
                        })
                    );
                }

                dispatch(LoveActions.setLoveListUpdated(false));
                dispatch(LoveActions.setCategoriesFilter([]));

                dispatch(
                    LoveActions.updateLovesListSkuDetails({
                        loves: allLovedItems.skus || []
                    })
                );

                onDataLoaded({ ...data, ...allLovedItems });

                onPageUpdated({ ...data, ...allLovedItems });

                return Promise.resolve();
            } catch (error) {
                onError(error);

                return Promise.reject(error);
            }
        };
    };
}

const MyListsPageActions = new MyListsActionCreators();

export default MyListsPageActions;
